<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-header">
          <div>
            <h3 class="card-title mr-1">{{ "UPDATE_COSTS" | translate }}</h3>
            <span class="text-muted font-small-3" *ngIf="!!lastUpdate">{{ "LAST_UPDATE" | translate }} {{ lastUpdate }}</span>
          </div>
          <div *ngIf="xlsx_file_content">
            <a class="btn btn-outline-secondary text-secondary mr-2" (click)="xlsx_file_content = null">{{ "RESET" | translate }}</a>
            <a class="btn btn-outline-primary text-primary" (click)="save()" *ngIf="_authenticationService.hasCapability('manage_contracts_costs')">{{ "IMPORT" | translate }}</a>
          </div>
        </div>
        <div class="card-body" *ngIf="!xlsx_file_content">
          <div class="row">
            <div class="col-lg-4">
              <fieldset>
                <div class="custom-file">
                  <input class="custom-file-input" type="file" lang="it" id="resignation-upload" accept="application/vnd.sealed.xls" (change)="handlerChangeFileInput($event)" />
                  <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                  <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-md-12">
              <p class="font-small-2 mt-1 mb-0">
                {{ "DOWNLOAD_TEMPLATE_FILE_FROM_HERE" | translate }} <a (click)="downloadTemplate()" class="text-primary">{{ "DOWNLOAD_IT_HERE" | translate }}</a
                >.
              </p>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pb-0" *ngIf="xlsx_file_content">
          <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [rows]="xlsx_file_content" [headerHeight]="50" [scrollbarV]="true" [scrollbarH]="true" [rowHeight]="70" [limit]="20" [footerHeight]="50">
            <ngx-datatable-column *ngFor="let key of _contractService.contract_costs_keys" [name]="key.toUpperCase() | translate" [prop]="key" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row[key] || 0 }}</ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
